<template>
  <div class="slick-slider slick-initialized" v-if="items && items.length">
    <swiper ref="kvSwiper" :options="swiperOpts" v-if="reset">
      <swiper-slide v-for="(item, index) in items" :key="index">
        <template v-if="item.tag == 'image'">
          <ImgHoverZoom :img-def="item.url + '?x-oss-process=image/resize,w_900/quality,q_95'" :img-zoom="item.url" />
        </template>
        <template v-else-if="item.tag == 'video'">
          <VideoWrap :vSrc="item.video" :iSrc="item.src || item.url" :isMuted="true" :showControls="true" />
        </template>
        <!-- <div class="carousel-item" v-if="item.tag=='image'">
          <img :src="item.url" :alt="detailInfo.product_name" />
        </div>
        <div class="carousel-item" v-if="item.tag=='video'">
          <VideoWrap :vSrc="item.video" :iSrc="item.src" :isMuted="true" :showControls="true" />
        </div> -->
      </swiper-slide>
    </swiper>
    <!-- 左右按钮 -->
    <!-- <SwiperNavigator :xSwiper="kvSwiper" :total="kvImages.length" /> -->
    <SwiperNavBtns :xSwiper="kvSwiper" :direction="direction" mode="sides" />
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import SwiperNavigator from "@/components/SwiperNavigator";
import SwiperNavBtns from "@/components/SwiperNavBtns";
import ImgHoverZoom from '@/components/ImgHoverZoom';
import VideoWrap from '@/components/VideoWrap';
import utils from "@/utils";

let $vm = null;

export default {
  name: "PDPSwiper",
  components: { swiper, swiperSlide, SwiperNavBtns, ImgHoverZoom, VideoWrap },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      kvSwiper: {},
      swiperOpts: {
        loop: true,
        speed: 1000,
        slidesPerView: 1,
        autoplay: false,
        observer: true,
        observeSlideChildren: true,
        observeParents: true,
        navigation: {
          prevEl: '.carousel__btn--prev',
          nextEl: '.carousel__btn--next'
        },
        on: {
          slidePrevTransitionStart() {
            $vm.direction = "prev";
          },
          slidePrevTransitionEnd() {
            $vm.direction = "";
          },
          slideNextTransitionStart() {
            $vm.direction = "next";
          },
          slideNextTransitionEnd() {
            $vm.direction = "";
          },
          slideChangeTransitionStart() {
            $vm.$nextTick(() => {
              let instance = $vm.$refs?.kvSwiper?.swiper;
              instance && $vm.$emit('slideChangeTransitionStart', instance);
            })
          },
          slideChangeTransitionEnd() {
            $vm.$nextTick(() => {
              let instance = $vm.$refs?.kvSwiper?.swiper;
              instance && $vm.$emit('slideChangeTransitionEnd', instance);
            });
          }
        }
      },
      reset: true,
      direction: "",
      swiperHeight: 780
    }
  },
  created() {
    $vm = this;
    this.doLayout = utils.throttle(this.doLayout, 100);
    this.initEvent();
  },
  mounted() {
    this.doLayout();
  },
  methods: {
    initEvent() {
      window.addEventListener("resize", this.doLayout, false);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("resize", this.doLayout, false);
      });
    },
    // 计算轮播高度
    doLayout() {
      let swiperWidth = document.querySelector(".swiper-slide").clientWidth;
      this.swiperHeight = swiperWidth * 1.3220;
      // this.kvSwiper.height = this.swiperHeight;
      Array.from(document.querySelectorAll(".swiper-slide")).map(item => {
        item.style.setProperty("height", `${this.swiperHeight}px`);
      });
    }
  },
  watch: {
    items(newValue) {
      this.reset = false;
      this.items = newValue;
      this.$nextTick(() => {
        this.reset = true;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .slick-slider /deep/ .video__wrap .video__element { object-fit: contain; }
</style>